import { render, staticRenderFns } from "./messageConfigurator.vue?vue&type=template&id=cd452b82"
import script from "./messageConfigurator.vue?vue&type=script&lang=js"
export * from "./messageConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports